import React, { useState } from 'react';
import AdminAssets from './AdminAssets';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminHome = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE}/admin/login`, {
        email,
        password
      });

      const { token, message } = response.data;

      // ✅ Store the token in localStorage (or use cookies if preferred)
      localStorage.setItem('token', token);

      console.log(message); // "Login successful"
      navigate('/admin/dashboard');
    } catch (err) {
      console.error("Login error:", err.response?.data || err.message);
      alert('Login failed');
    }
  };

  return (
    <>
      <AdminAssets />
      <div className="login-page">
        <div className="login-box">
          <div className="logo text-center">
            <img src="/assets/images/logo.png" width="50%" alt="Fortune Cloud Logo" />
          </div>
          <div className="card">
            <div className="body">
              <div className="msg">Sign in to start your session</div>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">person</i>
                </span>
                <div className="form-line">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="Email"
                    required
                    autoFocus
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className="input-group">
                <span className="input-group-addon">
                  <i className="material-icons">lock</i>
                </span>
                <div className="form-line">
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-8 p-t-5"></div>
                <div className="col-xs-4">
                  <button
                    className="btn btn-block bg-pink waves-effect"
                    onClick={handleLogin}
                  >
                    SIGN IN
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminHome;
